import { LoadingOutlined } from '@ant-design/icons';
import { Button, Col, Form, Modal, Row, Spin, message } from 'antd';
import React, { useEffect, useState } from 'react';
import liracrypt from '../Liracrypt/liracrypt';
import ApiErrorComp from '../ApiErrorComp/ApiErrorComp';
import StAddNew from '../../pages/DSeries/StAddNew';

const KanbanBoard = ({
    onTaskClick,
    params
}) => {
    const [commentBox, setCommentBox] = useState({
        open: false,
        data: null,
        typ: ''
    })
    const [commentForm] = Form.useForm();
    const [taskList, setTaskList] = useState([]);

    const [kanbanConfig, setKanbanConfig] = useState();

    const [dropOverlay, setDropOverlay] = useState('');
    const [loading, setLoading] = useState(true);
    const [logData, setLogData] = useState();
    useEffect(() => {
        setLoading(true);
        liracrypt.get('/pms/kanban/task', { ...params })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setKanbanConfig(data.config);
                    setTaskList(data.data);
                    setLoading(false);
                } else {
                    message.error('Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            })
    }, []);

    const handleDragEnter = (typ) => {
        setDropOverlay(typ);
    };

    const handleDragLeave = () => {
        //   setDropOverlay('');
    };

    const handleDragStart = (e, taskName) => {
        e.dataTransfer.setData('text/plain', JSON.stringify(taskName));
    };

    const handleDrop = (e, st) => {
        e.preventDefault();
        const task = JSON.parse(e.dataTransfer.getData('text/plain'));
        let __tasks = [...taskList];
        let _task = __tasks.find(x => x.taskid === task.taskid);
        if (_task.st === st) {
            setDropOverlay('');
            return
        };
        _task.st = st;
        _task = { ..._task, ...params };
        updateTask(_task, () => {
            setDropOverlay('');
            setCommentBox({
                open: true,
                data: _task,
                typ: ''
            })
        });
    };

    const updateTask = (task, cb) => {
        liracrypt.patch('/pms/kanban/task', { ...task })
            .then(({ data }) => {
                if (data.isSuccess) {
                    message.success(data.message || 'Updated Successfully');
                    setTaskList(data.data);
                    setKanbanConfig(data.config);
                    cb(data);
                } else {
                    message.error(data.message || 'Something went wrong');
                }
            }).catch(err => {
                ApiErrorComp();
                console.error(err);
            });
    };

    const updateTaskRmrk = (values) => {
        let task = { ...commentBox.data, ...values };
        updateTask(task, () => {
            setCommentBox({
                open: false,
                data: null,
                typ: ''
            })
        })
    }

    return (
        <div className="kanban-board" style={{ width: '100%', overflowX: 'auto' }}>
            <Row style={{ flexWrap: 'nowrap' }}>
                {
                    kanbanConfig?.st?.length &&
                    kanbanConfig.st.map((st, stIndx) => (
                        <Col key={`kanban-pms-${stIndx}`} span={6}>
                            <div className={`${st._id} task-box-container`}>
                                <p className='pms-card-header'>{st.label}</p>
                                <div className='scroller' style={{ padding: 10, position: 'relative' }}
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) => handleDrop(e, st._id)}
                                    onDragEnter={() => handleDragEnter(st._id)}
                                    onDragLeave={handleDragLeave}>
                                    {
                                        taskList?.length && (
                                            taskList.map((log, index) => (
                                                log.st === st._id &&
                                                <div style={{ background: st.colr }} title={log.taskid} onClick={() => onTaskClick({ taskid: log.taskid })} className="pms-card" key={`log-${index}`}
                                                    draggable
                                                    onDragStart={(e) => handleDragStart(e, { taskid: log.taskid })}>
                                                    {
                                                        log.taskData.map((x, i) => (
                                                            typeof (x.text) === 'string' ?
                                                                <p style={{ marginBottom: 4 }} className={x.class} key={i}>{x.text}</p> :
                                                                <div key={i} className={`${x.class} pms-key-val-wrapper`}>
                                                                    <p className='pms-card-key'>{x.text.key} </p>
                                                                    <p className='pms-card-val'>{x.text.value}</p>
                                                                </div>
                                                        ))
                                                    }
                                                </div>
                                            ))
                                        )
                                    }
                                    {dropOverlay === st._id && <div className="drop-overlay">Drop Here</div>}
                                </div>
                            </div>
                        </Col>
                    ))
                }
            </Row>

            <Modal maskClosable={false} cancelButtonProps={{ hidden: true }} okButtonProps={{ hidden: true }} open={commentBox.open} title={"Add Comment"} onCancel={() => {
                setCommentBox({
                    open: false,
                    typ: '',
                    data: null
                })
            }}>
                <>
                    <StAddNew
                        urlMethod={"GET"}
                        formName="AddCommentForm"
                        setSmodalTitle={title => { console.log(title) }}
                        initForm={commentForm}
                        colSpan={24}
                        urlEndpoint={'/smodal'}
                        urlData={{ dictName: 'PMS_TaskComment' }}
                        onFormSubmit={updateTaskRmrk}
                    />
                    <div style={{ width: '100%', justifyContent: 'center', display: 'inline-flex' }}>
                        <Button loading={false} htmlType='submit' type="primary" form={'AddCommentForm'}>Submit</Button>
                    </div>
                </>
            </Modal>
        </div>
    );
};

export default KanbanBoard;
